import { useState } from "react"
import { Link } from "react-router-dom"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

const PilgrimagePage = () => {
  const [activeTab, setActiveTab] = useState("routes")
  const [selectedRoute, setSelectedRoute] = useState(null)

  // Sample pilgrimage routes data
  const pilgrimageRoutes = [
    {
      id: "char-dham",
      name: "Char Dham Yatra",
      duration: "12-15 days",
      difficulty: "Moderate to Challenging",
      bestTime: "May to June, September to October",
      image: "/placeholder.svg?height=400&width=600",
      description:
        "The Char Dham Yatra is a pilgrimage to four sacred sites in the Indian Himalayas: Yamunotri, Gangotri, Kedarnath, and Badrinath. This journey is believed to cleanse all sins and open the path to salvation.",
      highlights: [
        "Yamunotri - Source of the sacred Yamuna River",
        "Gangotri - Origin of the holy Ganges River",
        "Kedarnath - One of the 12 Jyotirlingas of Lord Shiva",
        "Badrinath - Dedicated to Lord Vishnu",
      ],
      itinerary: [
        { day: "Day 1-2", activity: "Delhi to Haridwar/Rishikesh" },
        { day: "Day 3-4", activity: "Yamunotri Temple visit" },
        { day: "Day 5-6", activity: "Gangotri Temple visit" },
        { day: "Day 7-9", activity: "Kedarnath Temple visit (includes trekking)" },
        { day: "Day 10-12", activity: "Badrinath Temple visit" },
        { day: "Day 13-15", activity: "Return to Delhi via Rishikesh" },
      ],
    },
    {
      id: "jyotirlinga",
      name: "Dwadash Jyotirlinga Yatra",
      duration: "20-25 days",
      difficulty: "Moderate",
      bestTime: "October to March",
      image: "/placeholder.svg?height=400&width=600",
      description:
        "The Dwadash Jyotirlinga Yatra is a pilgrimage to the twelve sacred shrines of Lord Shiva, where Shiva is worshipped as a Jyotirlinga (pillar of light). These temples are spread across India and are considered highly sacred.",
      highlights: [
        "Somnath Temple in Gujarat",
        "Mallikarjuna Temple in Andhra Pradesh",
        "Mahakaleshwar Temple in Madhya Pradesh",
        "Omkareshwar Temple in Madhya Pradesh",
        "Kedarnath Temple in Uttarakhand",
        "Bhimashankar Temple in Maharashtra",
        "Kashi Vishwanath Temple in Uttar Pradesh",
        "Trimbakeshwar Temple in Maharashtra",
        "Vaidyanath Temple in Jharkhand",
        "Nageshwar Temple in Gujarat",
        "Rameshwaram Temple in Tamil Nadu",
        "Grishneshwar Temple in Maharashtra",
      ],
      itinerary: [
        { day: "Day 1-3", activity: "Start with Somnath Temple in Gujarat" },
        { day: "Day 4-6", activity: "Visit Mallikarjuna Temple in Andhra Pradesh" },
        { day: "Day 7-9", activity: "Visit Mahakaleshwar and Omkareshwar in MP" },
        { day: "Day 10-12", activity: "Visit Kedarnath in Uttarakhand" },
        { day: "Day 13-15", activity: "Visit Bhimashankar and Trimbakeshwar in Maharashtra" },
        { day: "Day 16-18", activity: "Visit Kashi Vishwanath in Varanasi and Vaidyanath in Jharkhand" },
        { day: "Day 19-21", activity: "Visit Nageshwar in Gujarat" },
        { day: "Day 22-25", activity: "Complete with Rameshwaram in Tamil Nadu and Grishneshwar in Maharashtra" },
      ],
    },
    {
      id: "shakti-peeth",
      name: "Shakti Peeth Yatra",
      duration: "25-30 days",
      difficulty: "Moderate to Challenging",
      bestTime: "October to March",
      image: "/placeholder.svg?height=400&width=600",
      description:
        "The Shakti Peeth Yatra is a pilgrimage to the sacred sites where parts of Goddess Sati's body fell after Lord Shiva carried her corpse. There are 51 Shakti Peeths spread across India, Nepal, Bangladesh, Pakistan, and Sri Lanka.",
      highlights: [
        "Kamakhya Temple in Assam",
        "Kalighat Temple in West Bengal",
        "Jwalamukhi Temple in Himachal Pradesh",
        "Chamundeshwari Temple in Karnataka",
        "Kanaka Durga Temple in Andhra Pradesh",
      ],
      itinerary: [
        { day: "Day 1-5", activity: "Start with Eastern India Shakti Peeths including Kamakhya and Kalighat" },
        { day: "Day 6-10", activity: "Visit North Indian Shakti Peeths including Jwalamukhi" },
        { day: "Day 11-15", activity: "Visit Central Indian Shakti Peeths" },
        { day: "Day 16-20", activity: "Visit Western Indian Shakti Peeths" },
        {
          day: "Day 21-30",
          activity: "Complete with Southern Indian Shakti Peeths including Chamundeshwari and Kanaka Durga",
        },
      ],
    },
    {
      id: "divya-desam",
      name: "Divya Desam Yatra",
      duration: "40-45 days",
      difficulty: "Moderate",
      bestTime: "October to March",
      image: "/placeholder.svg?height=400&width=600",
      description:
        "The Divya Desam Yatra is a pilgrimage to the 108 Vishnu temples glorified by the 12 Alvar saints in their Tamil hymns called Nalayira Divya Prabandham. Most of these temples are located in South India, particularly in Tamil Nadu.",
      highlights: [
        "Sri Ranganathaswamy Temple in Srirangam",
        "Tirupati Balaji Temple in Andhra Pradesh",
        "Srivilliputhur Andal Temple in Tamil Nadu",
        "Thiruvananthapuram Padmanabhaswamy Temple in Kerala",
        "Badrinath Temple in Uttarakhand",
      ],
      itinerary: [
        { day: "Day 1-10", activity: "Visit Tamil Nadu Divya Desams (40+ temples)" },
        { day: "Day 11-15", activity: "Visit Kerala Divya Desams" },
        { day: "Day 16-20", activity: "Visit Andhra Pradesh Divya Desams" },
        { day: "Day 21-25", activity: "Visit Karnataka Divya Desams" },
        { day: "Day 26-35", activity: "Visit North Indian Divya Desams" },
        { day: "Day 36-45", activity: "Complete remaining Divya Desams" },
      ],
    },
  ]

  // Sample pilgrimage packages data
  const pilgrimagePackages = [
    {
      id: "char-dham-budget",
      name: "Char Dham Budget Package",
      duration: "12 days",
      price: "₹45,000 per person",
      image: "/placeholder.svg?height=300&width=400",
      includes: [
        "Transportation from Delhi and back",
        "Accommodation in budget hotels/guesthouses",
        "Daily breakfast and dinner",
        "Guide services at all temples",
        "All permits and entry fees",
      ],
      excludes: ["Helicopter services", "Personal expenses", "Travel insurance", "Lunch meals"],
      nextDeparture: "May 15, 2023",
    },
    {
      id: "char-dham-deluxe",
      name: "Char Dham Deluxe Package",
      duration: "14 days",
      price: "₹75,000 per person",
      image: "/placeholder.svg?height=300&width=400",
      includes: [
        "Transportation from Delhi and back in AC vehicles",
        "Accommodation in 3-star hotels where available",
        "All meals included",
        "Guide services at all temples",
        "All permits and entry fees",
        "Helicopter service for Kedarnath",
      ],
      excludes: ["Personal expenses", "Travel insurance", "Alcoholic beverages"],
      nextDeparture: "May 20, 2023",
    },
    {
      id: "south-temple-tour",
      name: "South Indian Temple Tour",
      duration: "10 days",
      price: "₹35,000 per person",
      image: "/placeholder.svg?height=300&width=400",
      includes: [
        "Transportation from Chennai and back",
        "Accommodation in 3-star hotels",
        "Daily breakfast",
        "Guide services at all temples",
        "All permits and entry fees",
      ],
      excludes: ["Flights to Chennai", "Lunch and dinner", "Personal expenses", "Travel insurance"],
      nextDeparture: "June 5, 2023",
    },
    {
      id: "spiritual-varanasi",
      name: "Spiritual Varanasi Experience",
      duration: "5 days",
      price: "₹25,000 per person",
      image: "/placeholder.svg?height=300&width=400",
      includes: [
        "Accommodation in heritage hotels",
        "Daily breakfast and dinner",
        "Guided tours of temples and ghats",
        "Evening Ganga Aarti experience",
        "Boat ride on the Ganges",
        "Airport transfers",
      ],
      excludes: ["Flights to Varanasi", "Lunch meals", "Personal expenses", "Travel insurance"],
      nextDeparture: "Available year-round",
    },
  ]

  // Sample travel tips data
  const travelTips = [
    {
      title: "Prepare for Altitude",
      description:
        "Many sacred sites are located at high altitudes. Spend a day or two acclimatizing before ascending to higher elevations. Stay hydrated and consider carrying altitude sickness medication.",
      icon: "mountain",
    },
    {
      title: "Respect Dress Codes",
      description:
        "Most temples require modest attire. Women should cover their shoulders and knees, and men should avoid shorts. Some temples may require removing leather items before entering.",
      icon: "clothing",
    },
    {
      title: "Plan According to Season",
      description:
        "Many pilgrimage sites in the Himalayas are only accessible during specific months (May-June and September-October). Southern temples can be visited year-round but are best avoided during peak summer.",
      icon: "calendar",
    },
    {
      title: "Carry Essential Documents",
      description:
        "Always carry identification, necessary permits, and medical information. For certain restricted areas, foreign nationals may need special permits.",
      icon: "document",
    },
    {
      title: "Respect Local Customs",
      description:
        "Each temple has its own traditions and rituals. Follow the guidance of locals or temple authorities. Photography may be restricted in certain areas.",
      icon: "hands",
    },
    {
      title: "Pack Appropriately",
      description:
        "Carry comfortable walking shoes, weather-appropriate clothing, basic medications, a water bottle, and some dry snacks. A small offering for the temple is customary.",
      icon: "backpack",
    },
  ]

  // Function to render the icon based on the icon name
  const renderIcon = (iconName) => {
    switch (iconName) {
      case "mountain":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-nature-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        )
      case "clothing":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-nature-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
            />
          </svg>
        )
      case "calendar":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-nature-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        )
      case "document":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-nature-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        )
      case "hands":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-nature-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"
            />
          </svg>
        )
      case "backpack":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-nature-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
            />
          </svg>
        )
      default:
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-nature-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        )
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-divine-50 via-white to-sacred-50">
      <Navbar />

      {/* Hero Section */}
      <section className="relative py-20 px-4 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{ backgroundImage: "url('/placeholder.svg?height=1000&width=1920')" }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-nature-900/80 to-nature-800/80"></div>
        <div className="container mx-auto relative z-10 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">Sacred Pilgrimages</h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
            Embark on spiritual journeys to India's most revered temples and holy sites
          </p>
        </div>
      </section>

      {/* Tabs Section */}
      <section className="py-8 px-4 bg-white shadow-md relative z-10 -mt-8 rounded-t-3xl">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-wrap border-b border-gray-200">
            <button
              onClick={() => setActiveTab("routes")}
              className={`py-4 px-6 font-medium text-lg ${
                activeTab === "routes"
                  ? "border-b-2 border-nature-600 text-nature-700"
                  : "text-gray-500 hover:text-nature-600"
              }`}
            >
              Pilgrimage Routes
            </button>
            <button
              onClick={() => setActiveTab("packages")}
              className={`py-4 px-6 font-medium text-lg ${
                activeTab === "packages"
                  ? "border-b-2 border-nature-600 text-nature-700"
                  : "text-gray-500 hover:text-nature-600"
              }`}
            >
              Tour Packages
            </button>
            <button
              onClick={() => setActiveTab("tips")}
              className={`py-4 px-6 font-medium text-lg ${
                activeTab === "tips"
                  ? "border-b-2 border-nature-600 text-nature-700"
                  : "text-gray-500 hover:text-nature-600"
              }`}
            >
              Travel Tips
            </button>
          </div>
        </div>
      </section>

      {/* Pilgrimage Routes Tab Content */}
      {activeTab === "routes" && (
        <section className="py-12 px-4">
          <div className="container mx-auto max-w-6xl">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-nature-700 mb-4">Sacred Pilgrimage Routes</h2>
              <div className="w-24 h-1 bg-nature-500 mx-auto mb-6"></div>
              <p className="text-lg text-gray-700 max-w-3xl mx-auto">
                Discover the most revered pilgrimage circuits that have been followed by devotees for centuries
              </p>
            </div>

            {selectedRoute ? (
              // Detailed Route View
              <div className="bg-white rounded-xl shadow-xl overflow-hidden mb-8">
                <div className="relative h-64 md:h-96 overflow-hidden">
                  <img
                    src={selectedRoute.image || "/placeholder.svg"}
                    alt={selectedRoute.name}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 p-6 text-white">
                    <h2 className="text-3xl font-bold mb-2">{selectedRoute.name}</h2>
                    <div className="flex flex-wrap gap-4 text-sm">
                      <span className="bg-nature-600/80 px-3 py-1 rounded-full">
                        Duration: {selectedRoute.duration}
                      </span>
                      <span className="bg-nature-600/80 px-3 py-1 rounded-full">
                        Difficulty: {selectedRoute.difficulty}
                      </span>
                      <span className="bg-nature-600/80 px-3 py-1 rounded-full">
                        Best Time: {selectedRoute.bestTime}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={() => setSelectedRoute(null)}
                    className="absolute top-4 right-4 bg-white/80 text-gray-800 p-2 rounded-full hover:bg-white transition-colors"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <div className="p-6 md:p-8">
                  <div className="prose max-w-none">
                    <h3 className="text-2xl font-bold text-nature-700 mb-4">About This Pilgrimage</h3>
                    <p className="mb-6">{selectedRoute.description}</p>

                    <h3 className="text-2xl font-bold text-nature-700 mb-4">Highlights</h3>
                    <ul className="list-disc pl-5 mb-6 space-y-2">
                      {selectedRoute.highlights.map((highlight, index) => (
                        <li key={index}>{highlight}</li>
                      ))}
                    </ul>

                    <h3 className="text-2xl font-bold text-nature-700 mb-4">Sample Itinerary</h3>
                    <div className="overflow-x-auto">
                      <table className="min-w-full border-collapse mb-6">
                        <thead>
                          <tr className="bg-nature-50">
                            <th className="border border-nature-200 px-4 py-2 text-left">Day</th>
                            <th className="border border-nature-200 px-4 py-2 text-left">Activity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedRoute.itinerary.map((item, index) => (
                            <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-nature-50"}>
                              <td className="border border-nature-200 px-4 py-2">{item.day}</td>
                              <td className="border border-nature-200 px-4 py-2">{item.activity}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="mt-8 flex flex-col sm:flex-row gap-4">
                    <Link
                      to="/contact"
                      className="bg-nature-600 hover:bg-nature-700 text-white px-6 py-3 rounded-lg text-center font-semibold transition-colors"
                    >
                      Inquire About This Pilgrimage
                    </Link>
                    <button
                      onClick={() => setActiveTab("packages")}
                      className="bg-transparent hover:bg-nature-50 text-nature-700 border border-nature-600 px-6 py-3 rounded-lg text-center font-semibold transition-colors"
                    >
                      View Related Packages
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              // Routes List View
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {pilgrimageRoutes.map((route) => (
                  <div
                    key={route.id}
                    className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer transform hover:scale-105 transition-transform duration-300"
                    onClick={() => setSelectedRoute(route)}
                  >
                    <div className="relative h-48">
                      <img
                        src={route.image || "/placeholder.svg"}
                        alt={route.name}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 p-4 text-white">
                        <h3 className="text-xl font-bold mb-1">{route.name}</h3>
                        <div className="flex flex-wrap gap-2 text-xs">
                          <span className="bg-nature-600/80 px-2 py-0.5 rounded-full">Duration: {route.duration}</span>
                          <span className="bg-nature-600/80 px-2 py-0.5 rounded-full">
                            Difficulty: {route.difficulty}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="p-4">
                      <p className="text-gray-600 line-clamp-2 mb-4">{route.description}</p>
                      <button className="text-nature-600 hover:text-nature-800 font-medium flex items-center">
                        View Details
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 ml-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      )}

      {/* Tour Packages Tab Content */}
      {activeTab === "packages" && (
        <section className="py-12 px-4">
          <div className="container mx-auto max-w-6xl">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-nature-700 mb-4">Pilgrimage Tour Packages</h2>
              <div className="w-24 h-1 bg-nature-500 mx-auto mb-6"></div>
              <p className="text-lg text-gray-700 max-w-3xl mx-auto">
                Curated pilgrimage experiences with expert guides, comfortable accommodations, and hassle-free travel
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {pilgrimagePackages.map((pkg) => (
                <div key={pkg.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
                  <div className="relative h-48">
                    <img src={pkg.image || "/placeholder.svg"} alt={pkg.name} className="w-full h-full object-cover" />
                    <div className="absolute top-0 right-0 bg-nature-600 text-white px-3 py-1 rounded-bl-lg font-bold">
                      {pkg.price}
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-nature-700 mb-2">{pkg.name}</h3>
                    <div className="flex items-center text-gray-600 mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-2"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      Duration: {pkg.duration}
                    </div>

                    <div className="mb-4">
                      <h4 className="font-bold text-gray-700 mb-2">Package Includes:</h4>
                      <ul className="list-disc pl-5 space-y-1 text-gray-600">
                        {pkg.includes.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h4 className="font-bold text-gray-700 mb-2">Package Excludes:</h4>
                      <ul className="list-disc pl-5 space-y-1 text-gray-600">
                        {pkg.excludes.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="flex items-center justify-between mt-6">
                      <div className="text-sm bg-nature-100 text-nature-800 px-3 py-1 rounded-full">
                        Next Departure: {pkg.nextDeparture}
                      </div>
                      <Link
                        to="/contact"
                        className="bg-nature-600 hover:bg-nature-700 text-white px-4 py-2 rounded-lg font-semibold transition-colors"
                      >
                        Book Now
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-12 bg-nature-50 rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold text-nature-700 mb-4">Looking for a Custom Pilgrimage?</h3>
              <p className="text-gray-700 mb-6 max-w-3xl mx-auto">
                We can create personalized pilgrimage experiences tailored to your spiritual interests, time
                constraints, and budget. Our team of experts will design a journey that meets your specific
                requirements.
              </p>
              <Link
                to="/contact"
                className="bg-nature-600 hover:bg-nature-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors inline-flex items-center"
              >
                Contact for Custom Tour
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 ml-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* Travel Tips Tab Content */}
      {activeTab === "tips" && (
        <section className="py-12 px-4">
          <div className="container mx-auto max-w-6xl">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-nature-700 mb-4">Pilgrimage Travel Tips</h2>
              <div className="w-24 h-1 bg-nature-500 mx-auto mb-6"></div>
              <p className="text-lg text-gray-700 max-w-3xl mx-auto">
                Essential advice to make your spiritual journey comfortable, safe, and meaningful
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {travelTips.map((tip, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg p-6">
                  <div className="w-16 h-16 bg-nature-100 rounded-full flex items-center justify-center mb-4">
                    {renderIcon(tip.icon)}
                  </div>
                  <h3 className="text-xl font-bold text-nature-700 mb-3">{tip.title}</h3>
                  <p className="text-gray-600">{tip.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-12 bg-gradient-to-r from-nature-600 to-nature-800 text-white rounded-lg p-8">
              <div className="flex flex-col md:flex-row items-center">
                <div className="md:w-2/3 mb-6 md:mb-0 md:pr-8">
                  <h3 className="text-2xl font-bold mb-4">Download Our Pilgrimage Guide</h3>
                  <p className="mb-4">
                    Get our comprehensive guide to Indian pilgrimages with detailed information on sacred sites, best
                    times to visit, accommodation options, and spiritual significance.
                  </p>
                  <ul className="list-disc pl-5 mb-6 space-y-1">
                    <li>Complete information on major pilgrimage circuits</li>
                    <li>Packing checklists for different types of pilgrimages</li>
                    <li>Cultural etiquette and temple protocols</li>
                    <li>Health and safety tips for pilgrims</li>
                  </ul>
                </div>
                <div className="md:w-1/3 text-center">
                  <button className="bg-white text-nature-700 hover:bg-nature-50 px-6 py-3 rounded-lg font-semibold transition-colors inline-flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                      />
                    </svg>
                    Download Free Guide
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Testimonials Section */}
      <section className="py-16 px-4 bg-gradient-to-b from-nature-50 to-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-nature-700 mb-4">Pilgrim Experiences</h2>
            <div className="w-24 h-1 bg-nature-500 mx-auto mb-6"></div>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Hear from devotees who have embarked on spiritual journeys with us
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-nature-200 rounded-full flex items-center justify-center mr-4">
                  <span className="text-nature-800 font-bold text-xl">R</span>
                </div>
                <div>
                  <h4 className="font-bold">Rajesh Sharma</h4>
                  <p className="text-sm text-gray-500">Delhi, India</p>
                </div>
              </div>
              <p className="text-gray-600 italic">
                "My journey to the Char Dham was life-changing. The spiritual energy at Kedarnath temple is something I
                will never forget. The guides were knowledgeable and the arrangements were excellent. Highly recommend
                this pilgrimage to all devotees."
              </p>
              <div className="flex text-yellow-400 mt-4">
                <span>★</span>
                <span>★</span>
                <span>★</span>
                <span>★</span>
                <span>★</span>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-nature-200 rounded-full flex items-center justify-center mr-4">
                  <span className="text-nature-800 font-bold text-xl">S</span>
                </div>
                <div>
                  <h4 className="font-bold">Sunita Patel</h4>
                  <p className="text-sm text-gray-500">Mumbai, India</p>
                </div>
              </div>
              <p className="text-gray-600 italic">
                "The South Indian Temple Tour was beautifully organized. The architecture, the rituals, and the divine
                presence at each temple made it an unforgettable experience. The accommodations were comfortable and the
                food was excellent."
              </p>
              <div className="flex text-yellow-400 mt-4">
                <span>★</span>
                <span>★</span>
                <span>★</span>
                <span>★</span>
                <span>★</span>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-nature-200 rounded-full flex items-center justify-center mr-4">
                  <span className="text-nature-800 font-bold text-xl">M</span>
                </div>
                <div>
                  <h4 className="font-bold">Michael Brown</h4>
                  <p className="text-sm text-gray-500">London, UK</p>
                </div>
              </div>
              <p className="text-gray-600 italic">
                "As a foreigner, I was welcomed warmly at every temple. The guides were excellent at explaining the
                cultural and spiritual significance of each site. The Varanasi Experience was particularly moving with
                its sense of peace and community."
              </p>
              <div className="flex text-yellow-400 mt-4">
                <span>★</span>
                <span>★</span>
                <span>★</span>
                <span>★</span>
                <span>★</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-gradient-to-r from-nature-700 to-nature-900 text-white">
        <div className="container mx-auto max-w-5xl text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Begin Your Spiritual Journey Today</h2>
          <p className="text-xl max-w-3xl mx-auto mb-8">
            Whether you're seeking spiritual growth, cultural exploration, or a deeper connection with ancient
            traditions, our pilgrimage experiences offer something for every seeker.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-white text-nature-700 hover:bg-divine-100 px-8 py-3 rounded-lg text-lg font-semibold transition-colors"
            >
              Contact Us
            </Link>
            <Link
              to="/temple"
              className="bg-transparent hover:bg-white/10 text-white border-2 border-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors"
            >
              Explore Temples
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default PilgrimagePage

